import React, { useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Badge, OverlayTrigger, Popover } from 'react-bootstrap';
import moment from 'moment';
import { isObject } from 'lodash';
// import * as action from "../../../DevlopmentOrder/store/DevelopmentOrder.action"; // Removed - not needed since sample tracking is fetched in activeTheTab
import { useProductListingState } from '../RangePlanProductListingProvider';
import SampleApprovalStatusTag from '../../../../Components/SampleComment/SampleApprovalStatusTag';
import noImage from '../../../../assets/images/no-image.png';
import { shortenandHoverString } from '../../../../Components/helper';
import CommonImageComponent from '../../../../Components/Utility/CommonImage';
import Loader from '../../../../Components/Utility/Loader/Loader';

export default function ProductSample(props) {
  const { handlePageNextInScroll, loadNextData, handleSelection, selectedIds, isSelectAll } = props;
  const reducers = useSelector((redState) => redState);
  const { Measuremets } = reducers;
  const { sampleTrakingDates } = Measuremets;
  const isSupplierLoggedIn = reducers?.UserDetails?.isSupplierLoggedIn ?? false;
  const { t } = useTranslation('common');
  const dateFormat = 'DD-MMM-YYYY';
  const {
    rangePlanProvider: { productsNumber, productsList },
    lengthEnabled,
  } = useProductListingState();

  const [expandedRowIndex, setExpandedRowIndex] = useState([]);
  const [isExpandAll, setIsExpandAll] = useState(false);
  // const dispatch = useDispatch(); // Removed - no longer needed since sample tracking API is called in activeTheTab

  useEffect(() => {
    if (isExpandAll && productsList?.length > 0) {
      setExpandedRowIndex(productsList.map((_, index) => index));
    }
  }, [productsList?.length]);

  // Note: Sample tracking data is already fetched in activeTheTab function
  // when switching to the sample tab, so no need to fetch it again here

  const getValue = (value) => {
    if (isObject(value)) {
      return value?.name || '';
    }
    return value || '--';
  };

  const expandMoreData = (index) => {
    if (expandedRowIndex.includes(index)) {
      setIsExpandAll(false);
      setExpandedRowIndex(expandedRowIndex.filter((item) => item !== index));
    } else {
      setExpandedRowIndex([...expandedRowIndex, index]);
    }
  };

  const expandAll = () => {
    if (isExpandAll) {
      setIsExpandAll(false);
      setExpandedRowIndex([]);
    } else {
      setIsExpandAll(true);
      setExpandedRowIndex(productsList?.map((_, index) => index) || []);
    }
  };
  return (
    <div id="ProductSampleRPTableContainer" className="rp-scroll-container">
      <InfiniteScroll
        dataLength={productsList?.length}
        hasMore={productsList?.length < productsNumber}
        next={handlePageNextInScroll}
        loader={loadNextData && <Loader />}
        className="fixed-col-container rp-table-container"
        scrollableTarget="ProductSampleRPTableContainer"
      >
        <table id="RPProductSampleTable" className={`table common-custom-table fixed-header mb-0 ${!isSupplierLoggedIn ? 'has-approval-cols' : ''}`}>
          <thead>
            <tr>
              <th className="w-50px">
                <div className="common-checkbox margin-auto">
                  <input
                    type="checkbox"
                    onChange={(e) => handleSelection(e.target.checked)}
                    name="check_all_product_sample"
                    id="check_all_product_sample"
                    checked={isSelectAll}
                    disabled={!productsList?.length}
                  />
                  <label htmlFor="check_all_product_sample" className="chklabel" />
                </div>
              </th>
              <th className="w-50px">
                <button type="button" className="btn-up-down" aria-label={t('COMMON_LABEL.COLLAPSE')} onClick={() => expandAll()}>
                  {isExpandAll ? <span className="icon-new-down-arrow-icon icon-inverse" /> : <span className="icon-new-down-arrow-icon " />}
                </button>
              </th>
              <th className="w-80px">{t('RANGE_PLANS.PRODUCT_LIST.IMAGE')}</th>
              <th className="w-220px">{t('RANGE_PLANS.PRODUCT_LIST.PRODUCT_NUMBER')}</th>
              <th className="w-150px first-fix-col">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_SAMPLE_TABLE.SAMPLE_REF')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_SAMPLE_TABLE.SAMPLE_TYPE')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_SAMPLE_TABLE.SUPPLIER')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_SAMPLE_TABLE.GRADING_GROUP')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_SAMPLE_TABLE.COLOURWAY')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_SAMPLE_TABLE.SIZE')}</th>
              {lengthEnabled && <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_SAMPLE_TABLE.LENGTH')}</th>}
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_SAMPLE_TABLE.QUANTITY')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_SAMPLE_TABLE.UoM')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_SAMPLE_TABLE.DUE_DATE')}</th>
              {sampleTrakingDates?.map((masterDate) => {
                return (
                  masterDate?.isActive && (
                    <th className="w-150px" key={masterDate?._id}>
                      {masterDate?.name} {t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_SAMPLE_TABLE.DATE')}
                    </th>
                  )
                );
              })}
              <th className="w-150px last-fix-col status-sticky-col">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_SAMPLE_TABLE.STATUS')}</th>
              {!isSupplierLoggedIn && (
                <th className="w-150px licensing-sticky-col">{t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.COMMENT_COLUMNS.LICENSING_STATUS_LABEL', { ns: 'product-sample' })}</th>
              )}
              {!isSupplierLoggedIn && (
                <th className="w-150px customer-sticky-col">{t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.COMMENT_COLUMNS.CUSTOMER_STATUS_LABEL', { ns: 'product-sample' })}</th>
              )}
            </tr>
          </thead>

          {productsList?.length > 0 ? (
            productsList?.map((ele, productIndex) => {
              const initialData = ele?.initialData;

              const productImage = ele?.image || noImage;
              return (
                <tbody key={ele?._id}>
                  <tr>
                    <td>
                      <div className="common-checkbox margin-auto">
                        <input
                          onChange={() => {
                            handleSelection(ele?._id);
                          }}
                          name={`checks_${productIndex}`}
                          id={`checks_${productIndex}`}
                          type="checkbox"
                          checked={selectedIds?.filter((val) => val === ele?._id)?.length > 0}
                        />
                        <label htmlFor={`checks_${productIndex}`} className="chklabel" />
                      </div>
                    </td>
                    <td>
                      {ele?.expandData?.length > 0 && (
                        <button type="button" className="btn-up-down" aria-label={t('COMMON_LABEL.COLLAPSE')} onClick={() => expandMoreData(productIndex)}>
                          {expandedRowIndex.includes(productIndex) ? (
                            <span className="icon-new-down-arrow-icon icon-inverse" />
                          ) : (
                            <span className="icon-new-down-arrow-icon" />
                          )}
                        </button>
                      )}
                    </td>
                    <td>
                      <CommonImageComponent productImage={productImage} />
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        {ele?.number}
                        <button type="button" className="btn ml-auto" aria-label="info">
                          <OverlayTrigger
                            placement={t('TAKING_DATES.BUTTON')}
                            trigger="hover"
                            rootClose
                            overlay={
                              <Popover className="custom-popover">
                                <Popover.Content>
                                  <p className="mb-8">
                                    <b className="text-bold">Product Type: </b>
                                    {getValue(ele?.supplierType)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Description: </b>
                                    {getValue(ele?.description)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Brand: </b>
                                    {getValue(ele?.brandId)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Season: </b>
                                    {getValue(ele?.seasonId)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Month: </b>
                                    {getValue(ele?.month)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Year: </b>
                                    {getValue(ele?.year)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Colourway(s): </b>

                                    {ele?.colourLibraries?.map((gradEle) => gradEle?.name)?.join(', ') || '--'}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Size: </b>
                                    {ele?.sizeRanges?.join(', ') || '--'}
                                  </p>
                                </Popover.Content>
                              </Popover>
                            }
                          >
                            <span className="icon icon-Information f-20" />
                          </OverlayTrigger>
                        </button>
                      </div>
                    </td>
                    <td className="first-fix-col">
                      <div className="d-flex align-items-center">
                        {shortenandHoverString(initialData?.sampleNumber || '--', 8)}
                        {initialData?.sampleNumber && (
                          <Link
                            target="_blank"
                            // to={`/development-order/${ele?._id}/samples-details/comments?sample=${initialData?._id}`}
                            to={`/development-order/${ele?._id}/samples`}
                            className="px-3 ml-auto text-decoration-none"
                          >
                            <span className="icon-redirect f-20" />
                          </Link>
                        )}
                        <div style={{ width: 20 }}>
                          {ele?.expandData?.length >= 1 && <Badge className="range-badge badge badge-rp-counter">{(ele?.expandData?.length || 0) + 1}</Badge>}
                        </div>
                      </div>
                    </td>
                    <td>{shortenandHoverString(initialData?.sampleType?.name || '--', 40)}</td>
                    <td>{(initialData?.supplier?.companies?.length > 0 && initialData?.supplier?.companies[0]?.supplierName) || '--'} </td>
                    <td>{initialData?.colouways?.gradingGroup?.name || '--'}</td>
                    <td>{initialData?.colouways?.colourway?.name || '--'}</td>
                    <td>{initialData?.colouways?.size || '--'}</td>
                    {lengthEnabled && <td>{initialData?.colouways?.len?.name || '--'}</td>}
                    <td>{initialData?.colouways?.quantity || '--'}</td>
                    <td>{initialData?.colouways?.uom?.name || '--'}</td>
                    <td>{(initialData?.dueDate && moment(initialData?.dueDate).format(dateFormat)) || '--'}</td>
                    {sampleTrakingDates?.map((masterDate) => {
                      const sampleDate = initialData?.trackingDates?.find((date) => date?._id === masterDate?._id);
                      return (
                        masterDate?.isActive && <td key={masterDate?._id}>{(sampleDate?.value && moment(sampleDate?.value).format(dateFormat)) || '--'}</td>
                      );
                    })}
                    <td className="last-fix-col status-sticky-col">{initialData?.sampleStatus?.name}</td>
                    {!isSupplierLoggedIn && (
                      <td className="licensing-sticky-col">
                        {Boolean(initialData?.isLicensedProduct) ? (
                          <SampleApprovalStatusTag value={initialData?.licensingStatus} />
                        ) : (
                          <span className="sample-status-empty">--</span>
                        )}
                      </td>
                    )}
                    {!isSupplierLoggedIn && (
                      <td className="customer-sticky-col">
                        <SampleApprovalStatusTag value={initialData?.customerStatus} />
                      </td>
                    )}
                  </tr>
                  {expandedRowIndex.includes(productIndex) &&
                    ele?.expandData?.map((expData) => {
                      return (
                        <tr className="expand-row" key={expData?._id}>
                          <td />
                          <td />
                          <td />
                          <td />
                          <td className="first-fix-col">
                            <div className="d-flex align-items-center">{shortenandHoverString(expData?.sampleNumber || '--', 20)}</div>
                          </td>
                          <td>{shortenandHoverString(expData?.sampleType?.name || '--', 40)}</td>
                          <td>{(expData?.supplier?.companies?.length > 0 && expData?.supplier?.companies[0]?.supplierName) || '--'} </td>
                          <td>{expData?.colouways?.gradingGroup?.name || '--'}</td>
                          <td>{expData?.colouways?.colourway?.name || '--'}</td>
                          <td>{expData?.colouways?.size || '--'}</td>
                          {lengthEnabled && <td>{expData?.colouways?.len?.name || '--'}</td>}
                          <td>{expData?.colouways?.quantity || '--'}</td>
                          <td>{expData?.colouways?.uom?.name || '--'}</td>
                          <td>{(expData?.dueDate && moment(expData?.dueDate).format(dateFormat)) || '--'}</td>
                          {sampleTrakingDates?.map((masterDate) => {
                            const sampleDate = expData?.trackingDates?.find((date) => date?.sampleId === masterDate?._id);
                            return (
                              masterDate?.isActive && (
                                <td key={masterDate?._id}>{(sampleDate?.value && moment(sampleDate?.value).format(dateFormat)) || '--'}</td>
                              )
                            );
                          })}
                          <td className="last-fix-col status-sticky-col">{expData?.sampleStatus?.name}</td>
                          {!isSupplierLoggedIn && (
                            <td className="licensing-sticky-col">
                              {Boolean(expData?.isLicensedProduct) ? (
                                <SampleApprovalStatusTag value={expData?.licensingStatus} />
                              ) : (
                                <span className="sample-status-empty">--</span>
                              )}
                            </td>
                          )}
                          {!isSupplierLoggedIn && (
                            <td className="customer-sticky-col">
                              <SampleApprovalStatusTag value={expData?.customerStatus} />
                            </td>
                          )}
                        </tr>
                      );
                    })}
                </tbody>
              );
            })
          ) : (
            <tr>
              <td colSpan={8} className="text-center">
                {t('RANGE_PLANS.PRODUCT_LIST.NO_RECORDS_FOUND')}
              </td>
            </tr>
          )}
        </table>
      </InfiniteScroll>
    </div>
  );
}
